import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import PatientDetails from '../../pages/PracticeManagement/PatientManagement/PatientDetails';
import './AssignedReviewsModal.css';

const AssignedPatientReadingsModal = ({
  patientGroup,
  onClose,
  onAssignmentChanged
}) => {
  const practiceId = patientGroup?.practice_id;
  const patientId = patientGroup?.patient_id;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown, true);
    return () => window.removeEventListener('keydown', handleKeyDown, true);
  }, [onClose]);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  if (typeof document === 'undefined' || !practiceId || !patientId) return null;

  return createPortal(
    <div
      className="arm-overlay arm-overlay--stacked arm-overlay--patient-modal"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Patient details"
    >
      <div className="arm-patient-modal" onClick={(e) => e.stopPropagation()}>
        <div className="arm-patient-modal-bar">
          <button
            type="button"
            className="arm-patient-page-close"
            onClick={onClose}
            title="Close"
            aria-label="Close patient details"
          >
            &times;
          </button>
        </div>
        <div className="arm-patient-modal-scroll">
          <PatientDetails
            practiceId={practiceId}
            patientId={patientId}
            embeddedInModal
            onReviewStatusChange={() => {
              if (typeof onAssignmentChanged === 'function') onAssignmentChanged();
            }}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AssignedPatientReadingsModal;
